import logo from './logo.svg';
import { useEffect, useState } from 'react';
import './App.css';
import { Transition, TransitionGroup } from 'react-transition-group';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

/* Pages */
import Homepage from './components/Homepage';
import AboutPage from './components/PageAbout';
import Design from './components/PageDesign';
import ContactPage from './components/PageContact';
import StoryPage from './components/PageStory';
import Menu from './components/Menu';
import SeriesOne from './components/PageSeriesOne';
import SeriesTwo from './components/PageSeriesTwo';
import SeriesThree from './components/PageSeriesThree';
import SeriesSpecial from './components/PageSeriesSpecial';
import Landing from './components/Landing';
import BookPage from './components/BookCookieOne';
import Distro from './components/PageDistro';
import FAQ from './components/PageFAQ';
import Subscribe from './components/PageSubscribe'
import Press from './components/PagePress';
import CartPage from './components/Cart';
import Return from './components/ReturnPage';
import Kickstarter from './components/PageKickstarter';

import Vivek from './components/BookPageVivek';
import Bora from './components/BookPageBora';
import McKenzie from './components/BookPageMcKenzie';
import Enrique from './components/BookPageEnrique';
import CookieTwo from './components/BookPageCookieTwo';
import RayMike from './components/BookPageRayMike';
import Eileen from './components/BookPageEileen';
import Dodie from './components/BookPageDodie';
import Ashbery from './components/BookPageAshbery';
import Beckmann from './components/BookPageBeckmann';
import Daumal from './components/BookPageDaumal';
import Eka from './components/BookPageEka';
import CanXue from './components/BookPageCanXue';
import Jesse from './components/BookPageJesse';
import Bellatin from './components/BookPageBellatin';
import Georgi from './components/BookPageGeorgi';
import Flanagan from './components/BookPageFlanagan';
import Eileen1969 from './components/BookPageEileen1969';
import Michaux from './components/BookPageMichaux';
import Weil from './components/BookPageWeil';

import BoxSeriesThreeMidGreen from './components/BoxSetSeriesThreeMidGreen';
import BoxSeriesThreeRose from './components/BoxSetSeriesThreeRose';
import BoxSeriesThreeNeonYellow from './components/BoxSetSeriesThreeNeonYellow';
import BoxSeriesThreePurple from './components/BoxSetSeriesThreePurple';

//import CartPage from './components/Cart';
import { useRecoilState } from 'recoil';
import { cartState } from './atoms';
import FooterEmail from './components/FooterEmail';


function App() {
  const [cart, setCart] = useRecoilState(cartState);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let data = localStorage.getItem('hanumanCart');
    if (data && JSON.parse(data)) {
      setCart(JSON.parse(data));
    }
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (loaded) {
      localStorage.setItem('hanumanCart', JSON.stringify({ ...cart }));
    }
  }, [cart]);

  return (
    <Router>
      <div className="App">
        {/*<div class='bgNoise'></div>*/}
        <div className='appContainer'>
          <header className="App-header">
            <LogoSpace />
            <Menu />
          </header>
          <div className='appRouter'>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/books" element={<Landing />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/design" element={<Design />} />
              <Route path="/series/one" element={<SeriesOne />} />
              <Route path="/series/two" element={<SeriesTwo />} />
              <Route path="/series/three" element={<SeriesThree />} />
              <Route path="/series/special-editions" element={<SeriesSpecial />} />
              <Route path="/books/love-never-dies-eka-kurniawan" element={<Eka />} />
              <Route path="/books/kafka-and-i-can-xue" element={<CanXue />} />
              <Route path="/books/history-of-the-dolls-jesse-ball" element={<Jesse />} />
              <Route path="/books/mishimas-head-mario-bellatin" element={<Bellatin />} />
              <Route path="/books/space-opera-georgi-gospodinov" element={<Georgi />} />
              <Route path="/books/fuck-journal-bob-flanagan" element={<Flanagan />} />
              <Route path="/limited/series-three-box-set-mid-green" element={<BoxSeriesThreeMidGreen />} />
              <Route path="/limited/series-three-box-set-rose" element={<BoxSeriesThreeRose />} />
              <Route path="/limited/series-three-box-set-neon-yellow" element={<BoxSeriesThreeNeonYellow />} />
              <Route path="/limited/series-three-box-set-purple" element={<BoxSeriesThreePurple />} />
              {/* Series Two */}
              <Route path="/books/kuruntokai-vivek-narayanan" element={<Vivek />} />
              <Route path="/books/grocery-list-bora-chung" element={<Bora />} />
              <Route path="/books/life-story-mckenzie-wark" element={<McKenzie />} />
              <Route path="/books/insistence-as-a-fine-art-enrique-vila-matas" element={<Enrique />} />
              <Route path="/books/fan-mail-frank-letters-crank-calls-cookie-mueller" element={<CookieTwo />} />
              <Route path="/books/frontier-index-raymond-pettibon-mike-top" element={<RayMike />} />
              {/* Series One */}
              <Route path="/books/garden-of-ashes-cookie-mueller" element={<BookPage />} />
              <Route path="/books/bread-and-water-eileen-myles" element={<Eileen />} />
              <Route path="/books/feminine-hijinx-dodie-bellamy" element={<Dodie />} />
              <Route path="/books/the-ice-storm-john-ashbery" element={<Ashbery />} />
              <Route path="/books/on-my-painting-max-beckmann" element={<Beckmann />} />
              <Route path="/books/the-lie-of-the-truth-rene-daumal" element={<Daumal />} />
              {/* End Series */}
              <Route path="/books/1969-eileen-myles" element={<Eileen1969 />} />
              <Route path="/books/by-surprise-henri-michaux" element={<Michaux />} />
              <Route path="/books/on-the-lords-prayer-simone-weil" element={<Weil />} />
              <Route path="/flanagan-kickstarter" element={<Kickstarter />} />
              <Route path="/where-to-buy" element={<Distro />} />
              <Route path="/subscriptions" element={<Subscribe />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/press" element={<Press />} />
              <Route path="/frequently-asked-questions" element={<FAQ />} />
              <Route path="/from-the-editors" element={<StoryPage />} />
              <Route path="/return" element={<Return />} />
            </Routes>
          </div>
          <div className='appFooter'>
            <div className='footerLeft'>
              <div className='footerSocials'>
                <a href='https://www.instagram.com/hanumaneds/' target='_blank' rel='noreferrer'>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_32_493)">
                      <path d="M12 2.24113C15.204 2.24113 15.584 2.25312 16.85 2.31113C20.102 2.45913 21.621 4.00213 21.769 7.23012C21.827 8.49512 21.838 8.87513 21.838 12.0791C21.838 15.2841 21.826 15.6631 21.769 16.9281C21.62 20.1531 20.105 21.6991 16.85 21.8471C15.584 21.9051 15.206 21.9171 12 21.9171C8.796 21.9171 8.416 21.9051 7.151 21.8471C3.891 21.6981 2.38 20.1481 2.232 16.9271C2.174 15.6621 2.162 15.2831 2.162 12.0781C2.162 8.87412 2.175 8.49512 2.232 7.22913C2.381 4.00213 3.896 2.45813 7.151 2.31013C8.417 2.25313 8.796 2.24113 12 2.24113ZM12 0.078125C8.741 0.078125 8.333 0.092125 7.053 0.150125C2.695 0.350125 0.273 2.76813 0.073 7.13013C0.014 8.41113 0 8.81913 0 12.0781C0 15.3371 0.014 15.7461 0.072 17.0261C0.272 21.3841 2.69 23.8061 7.052 24.0061C8.333 24.0641 8.741 24.0781 12 24.0781C15.259 24.0781 15.668 24.0641 16.948 24.0061C21.302 23.8061 23.73 21.3881 23.927 17.0261C23.986 15.7461 24 15.3371 24 12.0781C24 8.81913 23.986 8.41113 23.928 7.13112C23.732 2.77712 21.311 0.351125 16.949 0.151125C15.668 0.092125 15.259 0.078125 12 0.078125ZM12 5.91612C8.597 5.91612 5.838 8.67513 5.838 12.0781C5.838 15.4811 8.597 18.2411 12 18.2411C15.403 18.2411 18.162 15.4821 18.162 12.0781C18.162 8.67513 15.403 5.91612 12 5.91612ZM12 16.0781C9.791 16.0781 8 14.2881 8 12.0781C8 9.86913 9.791 8.07812 12 8.07812C14.209 8.07812 16 9.86913 16 12.0781C16 14.2881 14.209 16.0781 12 16.0781ZM18.406 4.23313C17.61 4.23313 16.965 4.87812 16.965 5.67312C16.965 6.46812 17.61 7.11312 18.406 7.11312C19.201 7.11312 19.845 6.46812 19.845 5.67312C19.845 4.87812 19.201 4.23313 18.406 4.23313Z" fill="#262626" />
                    </g>
                    <defs>
                      <clipPath id="clip0_32_493">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.078125)" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a href='https://twitter.com/hanumaneditions' target='_blank' rel='noreferrer'>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.2737 10.2417L23.2023 0.078125H21.0872L13.3313 8.90117L7.14125 0.078125H0L9.3626 13.4214L0 24.0781H2.11504L10.3002 14.7587L16.8388 24.0781H23.98M2.8784 1.64002H6.12769L21.0856 22.593H17.8355" fill="#262626" />
                  </svg>
                </a>
              </div>
              <div className='footerLinks'>
                <Link to='/contact'>Contact</Link>
                <Link to='/press'>Press</Link>
                <Link to='/where-to-buy'>Distribution</Link>
                <Link to='/frequently-asked-questions'>FAQs</Link>
              </div>
            </div>
            <div className='footerRight'>
              <FooterEmail />
            </div>
          </div>
        </div>

      </div>
    </Router>
  );
}

function LogoSpace() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.pathname === '/') {
      document.body.classList.add('homepage');
    } else {
      document.body.classList.remove('homepage');
    }
  }, [location]);

  return (
    <div className='hanumanLogo'>
      <Link to={`${location.pathname === '/' ? '/books' : ''}`}>Hanuman<br />Editions</Link>
    </div>
  )
}

export default App;

